import {
    Component,
    Input,
    OnInit
} from '@angular/core';
import {EntityService, SolrEntityService} from "@signature-it/ngx-entity/services";
import {SolrOptionsEntityDTO} from "@signature-it/ngx-entity/models";
import {TranslateService} from "@ngx-translate/core";
import {EntityConfig} from "@signature-it/ngx-generic/config";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'custom-preview-entity',
    templateUrl: './custom-preview-entity.component.html',
    styleUrls: ['./custom-preview-entity.component.scss'],
    standalone: false
})
export class CustomPreviewEntityComponent  implements OnInit {

    @Input() key: string = 'default';
    @Input() previewTemplateVar: string;
    template: string = '';
    templates;
    EntityConfig;
    @Input() entityVar: string;
    item;
    constructor( public translateService: TranslateService,
                 protected entityService: EntityService,
                 protected activatedRoute: ActivatedRoute,
                 protected solrEntityService: SolrEntityService) {
    }

    ngOnInit(): void {
        let config;
        if(EntityConfig.ngxCustomPreviewEntity) {
            config = EntityConfig.ngxCustomPreviewEntity[this.key];
        }
        this.setConfig(config);
        this.getSolrData();
        this.getEntityPreview();
    }

    setConfig(config) {
        this.previewTemplateVar = this.previewTemplateVar || config['previewTemplateVar'];
        this.entityVar = this.entityVar || config['entityVar'];

    }
    getEntityPreview() {
        this.entityService.getEntityPreviews().subscribe(items => {
            this.templates = items || {};
            if (!this.previewTemplateVar) {
                this.previewTemplateVar = this.item.box_preview_var_s;
            }
            this.template = this.templates[this.previewTemplateVar];
        })
    }

    getSolrData() {
        const solrOptions = new SolrOptionsEntityDTO({
            entityVar: this.entityVar,
        });

        this.solrEntityService.getSolr(solrOptions).subscribe(
            solrResponse => {
                this.item = solrResponse['response']['docs'][0];
            }
        );
    }
}